import * as React from "react";

const Waiting = () => {
    return null;
}

export default Waiting;
